export default __webpack_public_path__ + "static/media/PPI-driveway-010.68028f81.jpg";